// extracted by mini-css-extract-plugin
export default {"card":"WqWVvPIkgz_ipsfJyNpm","titleWrapper":"bPgNv6nBA6W8kntyuX5r","icon":"oJvDQUHhSXYNcxhfIRbM","link":"qWgxr46uMnzoUfNDiYyQ","pulse":"gVR99dqcL1RNMltVvs0C"};